export enum ELeiGleifStav {
    LAPSED = 'LAPSED',
    MERGED = 'MERGED',
    RETIRED = 'RETIRED',
    ANNULLED = 'ANNULLED',
    CANCELLED = 'CANCELLED',
    TRANSFERRED = 'TRANSFERRED',
    PENDING_TRANSFER = 'PENDING_TRANSFER',
    PENDING_ARCHIVAL = 'PENDING_ARCHIVAL',
    PENDING_VALIDATION = 'PENDING_VALIDATION',
    DUPLICATE = 'DUPLICATE'
}
